module.exports = __webpack_public_path__ + "static/media/hotlistIcon.6354dafa.svg";